import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdChevronRight, MdOutlineDescription } from "react-icons/md";
import Carrier from "src/components/Carrier/Carrier";
import NoData from "@Components/NoData/NoData";
import GiftcardHtml from "src/Modules/GiftCards/pages/GiftcardDetails/components/GiftcardHtml/GiftcardHtml";

type Props = {
  termsAndCondition: string;
};

const TermsAndConditionsMob: FC<Props> = ({ termsAndCondition }) => {
  const { t } = useTranslation();
  const label = t("UserHistory.giftcard.termsAndConditions");

  return (
    <div className="flex w-full flex-col gap-3 text-start">
      <Carrier
        label={<span className="font-semibold">{label}</span>}
        renderTrigger={({ open }) => (
          <button
            type="button"
            onClick={open}
            className="bg-background-default outline-border-subtle flex w-full items-center gap-3 rounded-xl p-4 text-start outline transition-colors"
          >
            <div className="bg-background-primary-lighter text-icon-active flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
              <MdOutlineDescription className="h-5 w-5" />
            </div>
            <span className="text-font-default flex-1 text-sm font-semibold">{label}</span>
            <MdChevronRight className="text-icon-minimal h-5 w-5 shrink-0 rtl:-scale-x-100" />
          </button>
        )}
        renderSheet={() =>
          termsAndCondition ? (
            <GiftcardHtml className="text-font-default flex flex-col gap-2 p-4 text-xs" html={termsAndCondition} />
          ) : (
            <NoData description={t("UserHistory.giftcard.noTermsAndConditions")} />
          )
        }
      />
    </div>
  );
};

export default TermsAndConditionsMob;
